
import { defineComponent, computed } from 'vue'
import store from '@/store'
import FilterAndSearch from '@/components/IndexTemplates/FilterAndSearch.vue'
import TemplatesTable from '@/components/IndexTemplates/TemplatesTable.vue'
import BaseTablePanel from '@/components/Shared/BaseTablePanel.vue'

export default defineComponent({
  components: {
    FilterAndSearch,
    TemplatesTable,
    BaseTablePanel
  },
  emits: ['paginate'],
  setup() {
    const loading = computed(() => store.state.templates.loading)
    const currentKind = computed(
      () => store.state.templates.filterAndSearch.kind!
    )
    const config = computed(() => store.state.shared.config)

    return {
      loading,
      config,
      currentKind
    }
  }
})
